module.exports = __webpack_public_path__ + "static/devonPose.79f21382.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/devonPose.png
// module id = 395
// module chunks = 35783957827783 206603627034982